import * as PIXI from 'pixi.js'
import { Text } from 'pixi.js'

export default class objCopy {
    constructor(app, container) {
        this.app = app
        this.container = container

        this.copySprite = null
    }

    setCopyright() {
        const style = {
            dropShadow: true,
            dropShadowAngle: 0,
            dropShadowBlur: 5,
            dropShadowDistance: 0,
            fill: '#fff',
            fontSize: 12,
            fontFamily: ['YakuHanJP', 'Noto Sans JP', 'sans-serif'],
            fontWeight: 500,
            letterSpacing: 0.7,
            padding: 5,
        }

        const copyright = '©Paradox Live2024'

        this.copySprite = new Text(copyright, new PIXI.TextStyle(style))

        this.copySprite.x = 7.5
        this.copySprite.y = 609

        this.copySprite.zIndex = 10

        this.container.addChild(this.copySprite)
    }

    //コピーがあれば削除する
    removeSprite() {
        if (this.copySprite) {
            this.container.removeChild(this.copySprite)
            delete this.copySprite
        }
    }
}
